import React from "react"
import Tabs from '@material-ui/core/Tabs'
import Tab from '@material-ui/core/Tab'
import { ReactFC } from "types"
import styled from "styled-components"
import AppBar from "@material-ui/core/AppBar"
import { FormattedMessage } from "react-intl"
import { tabsStyle } from "navigation-ui/tabsStyle"

export const EventTabsWrapper = styled(AppBar).attrs({
    position: "static"
})`
    && .MuiTab-root  {
        ${tabsStyle}
    }    
`

export const EventTabs: ReactFC<{ value: number, handleChange: (event: React.ChangeEvent<{}>, value: any) => void }> = ({ value, handleChange }) => {
    return (
        <EventTabsWrapper>
            <Tabs value={value} onChange={handleChange} aria-label="simple tabs example">
                <Tab label={<FormattedMessage id="event.listing"/>} id="tab-listing" aria-controls="tabpanel-listing" />
                <Tab label={<FormattedMessage id="event.upcoming"/>} id="tab-upcoming" aria-controls="tabpanel-upcoming" />
                <Tab label={<FormattedMessage id="event.recent"/>} id="tab-recent" aria-controls="tabpanel-recent" />
            </Tabs>
        </EventTabsWrapper>
    )
}
